import React from 'react';
import { useNotificationFeatures, useUXFeatures, useAppConfig } from '../hooks/useStatsigFeatures';

export const StatsigExample: React.FC = () => {
  const { features: notificationFeatures, logEvent } = useNotificationFeatures();
  const { features: uxFeatures } = useUXFeatures();
  const config = useAppConfig();
  
  const handleFeatureClick = () => {
    logEvent('feature_demo_clicked', {
      unified_notifications: notificationFeatures.unifiedNotifications,
      enhanced_dashboard: uxFeatures.enhancedDashboard
    });
  };
  
  const handleTrackEvent = () => {
    logEvent('demo_event', {
      timestamp: Date.now(),
      user_action: 'button_click'
    });
  };

  return (
    <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">
        Statsig Feature Flags Demo
      </h2>
      
      <div className="space-y-4">
        <div className="p-4 border rounded-lg">
          <h3 className="font-semibold mb-2">Notification Features</h3>
          <ul className="space-y-1 text-sm">
            <li>Unified Notifications: {notificationFeatures.unifiedNotifications ? '✅ Enabled' : '❌ Disabled'}</li>
            <li>Banner Notifications: {notificationFeatures.bannerNotifications ? '✅ Enabled' : '❌ Disabled'}</li>
            <li>Bell Notifications: {notificationFeatures.bellNotifications ? '✅ Enabled' : '❌ Disabled'}</li>
            <li>Real-time Notifications: {notificationFeatures.realTimeNotifications ? '✅ Enabled' : '❌ Disabled'}</li>
          </ul>
          </div>

        <div className="p-4 border rounded-lg">
          <h3 className="font-semibold mb-2">UX Features</h3>
          <ul className="space-y-1 text-sm">
            <li>New Onboarding: {uxFeatures.newOnboarding ? '✅ Enabled' : '❌ Disabled'}</li>
            <li>Enhanced Dashboard: {uxFeatures.enhancedDashboard ? '✅ Enabled' : '❌ Disabled'}</li>
            <li>Improved Navigation: {uxFeatures.improvedNavigation ? '✅ Enabled' : '❌ Disabled'}</li>
            <li>Mobile Optimizations: {uxFeatures.mobileOptimizations ? '✅ Enabled' : '❌ Disabled'}</li>
          </ul>
          </div>

        <div className="p-4 border rounded-lg">
          <h3 className="font-semibold mb-2">Dynamic Configuration</h3>
          <ul className="space-y-1 text-sm">
            <li>Max Notifications/Hour: {config.maxNotificationsPerHour}</li>
            <li>Onboarding Steps: {config.onboardingSteps}</li>
            <li>Feature Rollout %: {config.featureRolloutPercentage}%</li>
            <li>Maintenance Mode: {config.maintenanceMode ? '🔧 Active' : '✅ Normal'}</li>
            <li>API Timeout: {config.apiTimeout}ms</li>
            <li>Debug Mode: {config.enableDebugMode ? '🐛 On' : '📱 Off'}</li>
          </ul>
      </div>
      
        <div className="flex space-x-4">
        <button
          onClick={handleFeatureClick}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Test Feature Click Event
        </button>
        <button
          onClick={handleTrackEvent}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
        >
          Track Custom Event
        </button>
      </div>
      </div>
    </div>
  );
}; 